import axios from "axios";
// const baseURL = "http://localhost:9000/api/v1";
const baseURL = "https://whatsappchatak.herokuapp.com/api/v1";
const instance = axios.create({
  baseURL,
});

export default instance;
